import React, { useContext } from 'react';

export const SocketContext = React.createContext({
    // showAlert: () => {},
});

export const useSocketContext = () => useContext(SocketContext);
export default SocketContext;
